import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("trico_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Logout automatico SOLO su 401 reale (token non valido o scaduto).
// Tutti gli altri errori (5xx, timeout, network, 502/504 dal proxy K8s
// durante analisi lente) NON devono mai sloggare l'utente né resettare lo
// stato globale: il componente che ha originato la chiamata gestisce l'errore
// localmente con un toast.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    if (status === 401) {
      localStorage.removeItem("trico_token");
      localStorage.removeItem("trico_user");
      const path = window.location.pathname;
      if (!path.startsWith("/login") && !path.startsWith("/register") && !path.startsWith("/r/")) {
        window.location.href = "/login";
      }
    }
    // Nessun altro status causa side-effects globali.
    return Promise.reject(err);
  }
);
